import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { TFunction } from 'i18next';
import { ROUTER_IN_PROGRESS_ORDERS } from 'app/AppRouter';
import { trackAppEvent } from 'app/AppTracker';
import PageViewCounter from 'components/Help/PageViewCounter';
import UserInfoTemp from 'components/UserInfoTemp';
import { getUserRights, UserRole } from 'domains/user';
import { MyOrdersRouter } from 'pages/MyOrdersPage/MyOrdersRouter';
import { ACCOUNT, ORDERS } from 'pages/ProfilePage/ProfilePage.types';
import { Flex, LinkTabs, Text } from 'UI';
import { getCondArrayItem, getData, hasUserAnyRight } from 'utils';
import { TRACKING_EVENT_ORDERS_IN_PROGRESS } from 'utils/eventTracker/EventTracker.types';
import { useResetScroll } from 'utils/hooks/useResetScroll';
import { Container } from './ProfilePage.styled';

const getNavigationItems = (t: TFunction, userRights: UserRole[]) => {
  return [
    {
      key: 1,
      label: t('profile.my_account', 'My account'),
      link: `/${ACCOUNT}`,
      component: <UserInfoTemp />,
      dataCy: 'my-account-button',
    },
    ...getCondArrayItem(
      hasUserAnyRight([UserRole.COMMAND, UserRole.CONNECT_COMMANDE, UserRole.R1_ORDER_AND_CLAIM], userRights) && {
        key: 5,
        label: t('order_plural', 'Orders'),
        link: `/${ORDERS}`,
        component: (
          <>
            <PageViewCounter page={ROUTER_IN_PROGRESS_ORDERS} />
            <MyOrdersRouter />
          </>
        ),
        additionalAction: () => trackAppEvent(TRACKING_EVENT_ORDERS_IN_PROGRESS),
        dataCy: 'order-button',
      },
    ),
  ];
};

const ProfilePage = (): JSX.Element => {
  const { t } = useTranslation();
  const userRights = useSelector(getUserRights);
  const navigationItems = getNavigationItems(t, getData(userRights) ?? []);
  useResetScroll();

  return (
    <Container>
      <Flex>
        <Text type={'h0'} data-cy={'my-profile-title'}>
          {t('profile.my_profile', 'My profile')}
        </Text>
      </Flex>
      <LinkTabs items={navigationItems} />
    </Container>
  );
};

export default ProfilePage;
